<template>
  <div class="container">
    <pi-cell-row name="账户信息" @click="accoutnInfo"></pi-cell-row>
    <!-- <pi-cell-row name="选择语言">简体中文</pi-cell-row> -->
  </div>
</template>
<script>
import cellRow from "@/components/pi-cell-row/pi-cell-row.vue";
export default {
  name: "car-list",
  data() {
    return {
      cardItem: {},
    };
  },
  components: {
    [cellRow.name]: cellRow,
  },
  methods: {
    accoutnInfo() {
      this.$router.push("/userinfo");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.card-content {
  padding: 0 0.2rem;
}
.cancel-btn {
  padding: 0.2rem 0;
  text-align: right;
  color: #14cc80;
  font-size: 0.28rem;
  line-height: 0.37rem;
}
.my-card {
  position: relative;
  height: 3.3rem;
}

.bg-card {
  width: 100%;
  height: 100%;
}
.card-title {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  font-size: 0.3rem;
  font-weight: 500;
  color: #ffffff;
  line-height: 0.42rem;
}
.card-no {
  position: absolute;
  bottom: 0.2rem;
  left: 0.4rem;
  font-size: 0.36rem;
  font-weight: 600;
  color: #ffffff;
  line-height: 0.5rem;
}
</style>